import { Box } from '@mui/material';
import React, { ReactElement } from 'react';

import { colorLightGrey, colorLightBlueWhite } from 'customColors';
import { BaseSkeleton } from '../Skeleton';

export const OrganizationClickCardSkeleton = (): ReactElement => (
  <Box
    sx={{
      display: 'flex',
      width: '100%',
      minWidth: 0,
      p: 16,
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 16,
      borderRadius: 8,
      overflow: 'hidden',
      border: `1px solid ${colorLightGrey}`,
      backgroundColor: colorLightBlueWhite,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <BaseSkeleton height="50px" width="50px" styles={{ borderRadius: 4 }} />
      <BaseSkeleton height="50px" width="80px" styles={{ borderRadius: 10 }} />
    </Box>
    <BaseSkeleton height="18px" width="80%" />
  </Box>
);
